import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";

const container = document.getElementById("root");
const root = ReactDOM.createRoot(container);

root.render(
  // Puedes activar StrictMode si quieres, pero puede causar doble montaje de efectos en desarrollo
  //<React.StrictMode>
    <App />
  //</React.StrictMode>
);

